import React from 'react';

export const ReadonlyContext = React.createContext<boolean>(true);

export function useReadonly() {
  return React.useContext(ReadonlyContext);
}
